export const QUALITY_ISSUE_LABELS = {
  missing_photos: "Sin fotos",
  missing_price: "Sin precio",
  missing_mileage: "Sin kilometraje",
  missing_description: "Sin descripción",
  missing_location: "Sin ubicación",
  stale_confirmation: "Confirmación obsoleta",
  unverified_dealer: "Dealer no verificado",
  missing_documentation: "Documentación incompleta",
  invalid_year: "Año inválido",
  invalid_price: "Precio inválido",
  invalid_mileage: "Kilometraje inválido",
  suspicious_price: "Precio sospechoso",
  suspicious_mileage: "Kilometraje sospechoso",
  possible_duplicate: "Posible duplicado",
  likely_duplicate: "Duplicado probable",
};

export const STALE_SEVERITY_LABELS = {
  low: "Bajo",
  medium: "Medio",
  high: "Alto",
};

export const STALE_SEVERITY_CLASS = {
  low: "admin-badge--warning",
  medium: "admin-badge--warning",
  high: "admin-badge--danger",
};

export const DUPLICATE_STATUS_LABELS = {
  exact_stock_match: "Stock exacto",
  exact_url_match: "URL exacta",
  exact_plate_match: "Placa exacta",
  exact_vin_match: "VIN exacto",
  likely_duplicate: "Duplicado probable",
  possible_duplicate: "Posible duplicado",
};

export const OUTLIER_FLAG_LABELS = {
  price_too_low: "Precio muy bajo",
  price_too_high: "Precio muy alto",
  mileage_too_high: "Km muy alto",
  mileage_too_low: "Km bajo para edad",
  invalid_year: "Año inválido",
  invalid_price: "Precio inválido",
  invalid_mileage: "Km inválido",
};

export const INCOMPLETE_ISSUE_GROUPS = [
  { value: "", label: "Todos" },
  { value: "missing_photos", label: "Sin fotos" },
  { value: "missing_key_data", label: "Datos clave faltantes" },
  { value: "missing_description", label: "Sin descripción" },
  { value: "low_quality", label: "Calidad baja" },
  { value: "missing_documentation", label: "Documentación" },
  { value: "unverified_dealer", label: "Dealer no verificado" },
];

export function trackInventoryQualityEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[inventory-quality-event]", eventType, metadata);
  }
}
